module.exports = __webpack_public_path__ + "assets/inspect.26d081ef.svg";